import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
import PostalRecipientEditor from "../_modules/postal-recipient-editor"
import type { PostalRecipientFormValue } from "../../postal-recipient-form"
import type {
  openRecipientQuickEdit,
  reloadRecipientQuickEditWorkOrders,
} from "../recipient-quick-edit-commands"

type PostalEditorInput = {
  manual: boolean
  initialValue: PostalRecipientFormValue
  onApply: (value: PostalRecipientFormValue) => string | null
}

export type PlanningRendererPorts = {
  openPostalRecipientEditor: (input: PostalEditorInput) => void
  openRecipientQuickEdit: typeof openRecipientQuickEdit
  reloadRecipientWorkOrders: typeof reloadRecipientQuickEditWorkOrders
}

export const openPostalRecipientEditor = (properties: PostalEditorInput) => {
  openOverlay({
    title: "Briefempfänger bearbeiten",
    content: PostalRecipientEditor,
    closeOnParentOpen: false,
    properties,
  })
}
